// Kept in a separate file following the reactQueryKeys convention so these keys
// can be reused for cache invalidation/removal (e.g. queryClient.invalidateQueries)
// from mutation hooks or other parts of the app without coupling to useHotelSearch.
export const all = ['hotelSearch'] as const
export const search = (
  placeName: string,
  region?: string,
  checkIn?: string,
  checkOut?: string,
  flexibleMonths?: string,
  flexibleNights?: string,
  placeId?: string,
  occupancies?: Array<App.Occupants>,
) =>
  [...all, placeName, region, checkIn, checkOut, flexibleMonths, flexibleNights, placeId, occupancies] as const
